// Click.js
import React from 'react';

const Click = () => {
  return (
    <div className="page">
      <h2>Click Page</h2>
      <p>This is the Click page where users can tap to earn crypto.</p>
    </div>
  );
};

export default Click;
